import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

/**
 * Аутентификация: контекст + провайдер + guard для роутов.
 * Вынесено из App.js. AuthContext/AuthProvider реэкспортятся из App.js
 * ради обратной совместимости со старыми импортами.
 */

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser && storedUser !== "undefined" && storedUser !== "null") {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Error parsing stored user:", error);
        localStorage.removeItem("user");
      }
    } else {
      // Очищаем некорректные данные
      localStorage.removeItem("user");
    }

    fetch(`${PATH_TO_BACKEND}/api/check-session`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setUser(data.data.user);
          localStorage.setItem("user", JSON.stringify(data.data.user));
        } else {
          setUser(null);
          localStorage.removeItem("user");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Ошибка проверки сессии:", err);
        setUser(null);
        localStorage.removeItem("user");
        setLoading(false);
        setError("Не удалось проверить сессию. Пожалуйста, войдите снова.");
      });
  }, []);

  const login = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = async () => {
    try {
      await fetch(`${PATH_TO_BACKEND}/api/logout`, {
        method: "POST",
        credentials: "include",
      });
      localStorage.removeItem("user");
      setUser(null);
    } catch (err) {
      console.error("Ошибка при выходе:", err);
      // Даже при ошибке очищаем локальное состояние
      localStorage.removeItem("user");
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, role: user?.role, login, logout, loading, error }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {" "}
        <CircularProgress size="7rem" />{" "}
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" />;
  }
  return children;
};
